import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  CardContentTypes,
  ContentTypes,
  GridCardService,
} from '@app/library/panes/grid-card-universal/grid-card.service';
import { ChangableComponent } from '@models/changable.component';
import { Collection, Content, CSchool, Meeting, User, UserService } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { AccountSharedModule } from '@app/account/account-shared.module';
import { CollectionLicensePricesModule } from '@app/collections/shared/collection-license-prices/collection-license-prices.module';
import { CollectionMetaModule } from '@app/collections/shared/collection-meta/collection-meta.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { UserServiceCardFullModule } from '@app/meetings/user-service-card-full/user-service-card-full.module';
import { SchoolFormModule } from '@app/school-settings/school-form/school-form.module';
import { SchoolPageModule } from '@app/schools/school-page/school-page.module';
import { TeacherCardModule } from '@app/teachers/teacher-card/teacher-card.module';
import { AlertModule } from '@core/components/alert/alert.module';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { CoreModule } from '@core/core.module';
import { PipesModule } from '@core/pipes/pipes.module';
import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ClipboardModule } from 'ngx-clipboard';
import { OnUiButtonModule, OnUiCardMenuModule, OnUiCoverModule, OnUiPopoverModule } from 'onclass-ui';
import { CollectionComponent } from '../components/collection/collection.component';
import { LessonComponent } from '../components/lesson/lesson.component';
import { SchoolComponent } from '../components/school/school.component';
import { UserServiceComponent } from '../components/service/user-service.component';
import { TutorsComponent } from '../components/tutors/tutors.component';

@Component({
  selector: 'app-vertical-card',
  templateUrl: './vertical-card.component.html',
  styleUrls: ['./vertical-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    LocaleSharedModule,
    CommonModule,
    CoreModule,
    RouterModule,
    ModalModule,
    MobileModalModule,
    PipesModule,
    AlertModule,
    IconComponent,
    OnUiCardMenuModule,
    OnUiCoverModule,
    OnUiButtonModule,
    BookmarkComponent,
    UserServiceCardFullModule,
    CollectionMetaModule,
    OnUiPopoverModule,
    CollectionLicensePricesModule,
    LazyLoadImageModule,
    SchoolFormModule,
    SchoolPageModule,
    ClipboardModule,
    LibraryElementsModule,
    TeacherCardModule,
    AccountSharedModule,
    RatingComponent,
    UserServiceComponent,
    TutorsComponent,
    CollectionComponent,
    LessonComponent,
    SchoolComponent,
  ],
  providers: [GridCardService],
})
export class VerticalCardComponent extends ChangableComponent implements OnInit {
  gridCardService = inject(GridCardService);
  deviceService = inject(DeviceDetectorService);

  @Input()
  public set content(content: UserService | User | Meeting | CSchool | Collection | Content) {
    this._content = content;
  }

  @Input()
  public set contentType(type: CardContentTypes) {
    this._contentType = type;
  }

  public get contentType() {
    return this._contentType;
  }

  @Output() favoriteChanged = new EventEmitter<boolean>();

  @Output() openCard = new EventEmitter<ContentTypes>();

  public surfaceBlockDisplay: boolean;

  public expandSchoolStats = false;
  public _contentType: CardContentTypes;

  public _content: UserService | User | Meeting | CSchool | Collection | Content;

  ngOnInit(): void {}

  public onToggleInModal(data: UserService | Content | User | Collection | CSchool) {
    this.openCard.emit(data);
  }

  public onIinViewportChange(e) {
    this.surfaceBlockDisplay = e;
    this.markForCheck();
  }
}
